


































import { Component, Vue } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { CustodianDrivewealthListRequest, UpdateCustodianDefaultAgreementRequest } from "@/admin/types";
import { AgreementCategory, DrivewealthAccountManagementType, UserPermission } from "@/shared/types";
import { useInstrumentListStore } from "@/admin/store/instrumentList";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useNotifierStore } from "@/shared/store/notifier";

@Component
export default class InstrumentMetadata extends Vue {
  $validator: Validator;

  instrumentListStore = useInstrumentListStore();
  rolePermissionsStore = useRolePermissionsStore();
  signingDocumentStore = useSigningDocumentStore();
  notifierStore = useNotifierStore();

  isLoaded = false;
  isSubmitting = false;
  file = null;

  defaultAgreements = [];

  created () {
    this.instrumentListStore.loadInstrumentLists();
    this.signingDocumentStore.loadAllAdmin();
  }

  get submitDisabled (): boolean {
  return this.isSubmitting || !this.file;
}

submit (): void {
  if (!this.file) return;
  if (this.isSubmitting) return;

  this.isSubmitting = true;

  this.instrumentListStore.processInstrumentMetadataFile({
    csv: this.file
  })
    .finally(() => {
      this.isSubmitting = false;
      this.file = null;
    });
}


  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit);
  }


}
